/**
 * Created by maximus on 11.01.17.
 */
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.getProductForSlider = getProductForSlider;
exports.getCategoryForSlider = getCategoryForSlider;

var _constants = require('redux/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Получить список товаров по типу для слайдера
 * @param sliderType Тип товаров
 */
function getProductForSlider(sliderType) {
    return {
        types: [_constants.SliderConstants.SLIDER_LOAD, _constants.SliderConstants.SLIDER_LOAD_SUCCESS, _constants.SliderConstants.SLIDER_LOAD_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.getProductForSlider(sliderType).then(function (result) {
                return (0, _extends3.default)({}, result, {
                    sliderType: sliderType
                });
            });
        }
    };
}

/**
 * Получить список категорий
 */
function getCategoryForSlider() {
    return {
        types: [_constants.SliderConstants.SLIDER_LOAD_CATEGORY, _constants.SliderConstants.SLIDER_LOAD_CATEGORY_SUCCESS, _constants.SliderConstants.SLIDER_LOAD_CATWGORY_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.getCategoryForSlider();
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/actions/sliders.js
// module id = 767
// module chunks = 0